/**
 * Created by m.igrachev on 6/19/2017.
 */
import Validatable from "../../validatable/Validatable";
const ValidatableProps = Validatable.documentedProps;
const documentedProperties = [].concat(ValidatableProps, [
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to CheckboxItem."
    },
    {
        name: "value",
        type: "String",
        defaultValue: "n/a",
        isRequired: "true",
        description: "The value of the checkbox item."
    },
    {
        name: "label",
        type: "String",
        defaultValue: "=value",
        isRequired: "false",
        description: "The label of the checkbox item. If not set is equal to value."
    },
    {
        name: "disabled",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true, flags the checkbox item as disabled."
    },
    {
        name: "active",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true, flags the checkbox item as checked."
    },
    {
        name: "marked",
        type: "Boolean",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "A marker for Multiselect needs. It mark CheckboxItem as current while interacting with keyboard arrows."
    },
    {
        name: "onClick",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "This callback comes from checkbox group and cannot be overridden on option level."
    }
]);

export default documentedProperties;
